import React from "react";
import CookieConsent from "react-cookie-consent";
import { useNavigate } from "react-router-dom";

const CookieBanner = () => {
  const navigate = useNavigate();

  return (
    <CookieConsent
      cookieName="CookieAggrement"
      expires={999}
      buttonClasses="btn btn-primary"
      buttonText="Akceptuj"
      style={{
        background: "#2F4858",
        justifyContent: "center",
        paddingRight: 50,
        paddingLeft: 50,
      }}
      buttonStyle={{
        marginTop: "0px",
        backgroundColor: "#fae4e7",
        fontWeight: "bold",
      }}
      contentStyle={{ flex: "0 0 100%", textAlign: "justify" }}
    >
      Strona Checkardi korzysta z plików cookies w celu prawidłowego
      funkcjonowania elementów serwisu. Korzystając ze strony wyrażają Państwo
      zgodę na używanie plików cookies oraz akceptują warunki
      <span
        style={{
          color: "white",
          cursor: "pointer",
          paddingLeft: 3,
          fontWeight: "bold",
          textDecoration: "underline",
        }}
        onClick={() => navigate("/policyterm")}
      >
        polityki prywatności
      </span>
    </CookieConsent>
  );
};

export default CookieBanner;
